import React from 'react'
import { Autocomplete, Chip, TextField } from '@mui/material'

export interface TagInputProps {
  /** Current tags. */
  value: string[]
  onChange: (value: string[]) => void
  label?: string
  placeholder?: string
  helperText?: React.ReactNode
}

/**
 * Free-text chip/token input (MUI `Autocomplete` freeSolo + multiple). Users
 * type a term and press Enter to add it as a removable chip; there is no
 * option list. Reusable for any "list of strings" field - see
 * docs/development/admin-forms.md.
 */
const TagInput: React.FC<TagInputProps> = ({
  value,
  onChange,
  label,
  placeholder,
  helperText,
}) => (
  <Autocomplete<string, true, false, true>
    multiple
    freeSolo
    options={[]}
    value={value}
    onChange={(_event, next) =>
      // Trim, drop blanks + duplicates so chips stay clean.
      onChange(
        Array.from(
          new Set(next.map((t) => t.trim()).filter((t) => t.length > 0)),
        ),
      )
    }
    renderTags={(tags, getTagProps) =>
      tags.map((tag, index) => {
        const { key, ...chipProps } = getTagProps({ index })
        return <Chip key={key} variant="outlined" size="small" label={tag} {...chipProps} />
      })
    }
    renderInput={(params) => (
      <TextField
        {...params}
        label={label}
        placeholder={placeholder}
        helperText={helperText}
        size="small"
      />
    )}
  />
)

export default TagInput
